<template>
    <NewCuponForm
        layout="page"
        @success="onSuccess"
        @cancel="goBack"
    />
</template>

<script>
    import NewCuponForm from '@/components/Weflix/Payment/NewCuponForm.vue';

    export default {
        components: {
            NewCuponForm,
        },
        methods: {
            onSuccess() {
                this.$router.push('/admin/pagamentos');
            },
            goBack() {
                this.$router.push('/admin/pagamentos');
            },
        },
    };
</script>
